type PngImageType = {
  src: string
}

export const getSrcImage = (image: string | PngImageType): string => (typeof image === 'string' ? image : image.src)
